export default "__VITE_ASSET__DKVAJ4IT__"